import { put } from "redux-saga/effects";
import { message } from "antd";

import UserApiCaller from "../../config/api/userapicaller";
import MediaApiCaller from "../../config/api/mediaapicaller";

import { ProfileAction } from "../actions";

export default class ProfileMiddleware {
  static *getProfile({ cb }) {
    try {
      const res = yield UserApiCaller.Get("/user/profile");
      if (res.data.data.responseMeta.httpStatusCode === 200) {
        yield localStorage.setItem("username", res.data.data?.user?.username);
        yield put(ProfileAction.getProfileSuccess(res.data.data?.user));
      } else {
        yield put(ProfileAction.getProfileFailure());
      }
      if (cb) {
        cb(res.data.data?.user);
      }
    } catch (err) {
      // message.error("Something went wrong. Please try again.");
      yield put(ProfileAction.getProfileFailure());
    }
  }
  static *removeProfileStore({ cb }) {
    try {
      yield put(ProfileAction.removeProfileStoreSuccess());
      if (cb) {
        cb();
      }
    } catch (err) {
      yield put(ProfileAction.removeProfileStoreFailure());
    }
  }
  static *changeRequest({ payload, cb }) {
    try {
      const res = yield UserApiCaller.Post("/user/attrchange", payload);
      if (res.status === 200) {
        message.success("Request sent to admin successfully.");
        yield put(ProfileAction.changeRequestSuccess());
      } else {
        yield put(ProfileAction.changeRequestFailure());
        message.error(res?.data?.message);
      }
      if (cb) {
        cb(res.data.Data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(ProfileAction.changeRequestFailure());
    }
  }
  static *changeProfileStatus({ payload, cb }) {
    try {
      const res = yield UserApiCaller.Put("/user/profile", payload);
      if (res.data?.Data?.httpStatusCode === 200) {
        yield put(ProfileAction.changeProfileStatusSuccess());
      } else {
        yield put(ProfileAction.changeProfileStatusFailure());
      }
      if (cb) {
        cb(res.data.Data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(ProfileAction.changeProfileStatusFailure());
    }
  }
  static *updateProfile({ payload, cb }) {
    try {
      const res = yield UserApiCaller.Put("/user/profile", payload);
      if (res.status === 200) {
        message.success("Profile updated successfully");
        yield put(ProfileAction.updateProfileSuccess());
        yield put(ProfileAction.getProfile());
      } else {
        message.error("Something went wrong. Please try again.");
        yield put(ProfileAction.updateProfileFailure());
      }
      if (cb) {
        cb(res.data.Data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(ProfileAction.updateProfileFailure());
    }
  }
  static *updateProfilePic({ payload, cb }) {
    try {
      const res = yield UserApiCaller.Put("/user/profilepicture", payload);
      if (res.data.Data.httpStatusCode === 200) {
        message.success("Profile picture updated successfully");
        yield put(ProfileAction.updateProfilePicSuccess());
        yield put(ProfileAction.getProfile());
      } else {
        message.error("Something went wrong.");
        yield put(ProfileAction.updateProfilePicFailure());
      }
      if (cb) {
        cb(res.data.Data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(ProfileAction.updateProfilePicFailure());
    }
  }

  static *uploadPhoto({ payload, cb }) {
    try {
      const res = yield MediaApiCaller.Post("/media/uploadphoto", payload);

      if (res.status === 200) {
        yield put(ProfileAction.uploadPhotoSuccess());
        yield put(ProfileAction.getProfile());
      } else {
        yield put(ProfileAction.uploadPhotoFailure());
      }
      if (cb) {
        cb(res);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(ProfileAction.uploadPhotoFailure());
    }
  }
  static *uploadTrustBadge({ payload, cb }) {
    try {
      const res = yield MediaApiCaller.Post("/media/uploadidentity", payload);
      if (res.status === 200) {
        message.success("Document uploaded successfully");
        yield put(ProfileAction.uploadTrustBadgeSuccess());
      } else {
        message.error("Document upload failed. Please try again.");
        yield put(ProfileAction.uploadTrustBadgeFailure());
      }
      if (cb) {
        cb(res);
      }
    } catch (err) {
      message.error("Document upload failed. Please try again.");
      yield put(ProfileAction.uploadTrustBadgeFailure());
    }
  }
  static *getTrustBadge({ payload, cb }) {
    try {
      const res = yield UserApiCaller.Get("/user/identity");

      if (res.status === 200) {
        yield put(ProfileAction.getTrustBadgeSuccess(res.data.Data));
      } else {
        yield put(ProfileAction.getTrustBadgeFailure());
      }
      if (cb) {
        cb(res);
      }
    } catch (err) {
      yield put(ProfileAction.getTrustBadgeFailure());
    }
  }
  static *deleteTrustBadge({ payload, cb }) {
    try {
      const res = yield UserApiCaller.Post("/user/deleteidentity", payload);

      if (res.status === 200) {
        yield put(ProfileAction.deleteTrustBadgeSuccess(res.data.Data));
      } else {
        yield put(ProfileAction.deleteTrustBadgeFailure());
      }
      if (cb) {
        cb(res);
      }
    } catch (err) {
      yield put(ProfileAction.deleteTrustBadgeFailure());
    }
  }
  static *deletePhoto({ payload, cb }) {
    try {
      const res = yield UserApiCaller.Put("/user/deletegallery", payload);

      if (res.status === 200) {
        message.success("Photo deleted successfully");
        yield put(ProfileAction.deletePhotoSuccess());
        yield put(ProfileAction.getProfile());
      } else {
        message.error("Something went wrong");
        yield put(ProfileAction.deletePhotoFailure());
      }
      if (cb) {
        cb(res);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(ProfileAction.deletePhotoFailure());
    }
  }
  static *getPromo({ payload, cb }) {
    try {
      const res = yield UserApiCaller.Post("/user/offers");
      if (res?.responseMeta?.httpStatusCode === 200) {
        yield put(ProfileAction.getPromoSuccess(res?.data));
      } else {
        yield put(ProfileAction.getPromoFailure());
      }
      if (cb) {
        cb(res);
      }
    } catch (err) {
      yield put(ProfileAction.getPromoFailure());
    }
  }
}
